import { TFunction } from 'react-i18next';

export const EMPLOYEE_ACCOUNT_TYPES = {
  user_standard: 'user_standard',
  service_automation: 'service_automation',
  service_integration: 'service_integration',
} as const;

export type EmployeeAccountTypes = ValueOf<typeof EMPLOYEE_ACCOUNT_TYPES>;

export const getServiceAccountPostFix = (
  accountType: EmployeeAccountTypes,
  t: TFunction
): string => {
  switch (accountType) {
    case 'service_automation':
      return t('via Code Step');

    case 'service_integration':
      return t('via Plugin');

    default:
      return '';
  }
};
